import { getAxiosClient } from "../../axios-client";
import { AddressAddBody, AddressAddResponse } from "./types";


const axiosClient = getAxiosClient();
export const addressAdd = async (
  body: AddressAddBody
) => {
  return await axiosClient.ax.post<AddressAddResponse>(
    "/Address/Add",
    body
  );
};
